var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"catalog__list"},_vm._l((_vm.hotels),function(hotel){return _c('HotelItem',{key:hotel.title,attrs:{"hotel":hotel}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }